import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import logoJatear from '../../assets/logo_jatear.png';
import styles from './Login.module.css';

export default function TrocarSenha() {
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const navigate = useNavigate();
  const trocarSenha = useAuthStore((s) => s.trocarSenha);
  const usuario = useAuthStore((s) => s.usuario);
  const logout = useAuthStore((s) => s.logout);

  async function handleSalvar(e) {
    e.preventDefault();
    setErro('');

    if (senha.length < 6) {
      setErro('A senha deve ter ao menos 6 caracteres.');
      return;
    }
    if (senha !== confirmar) {
      setErro('As senhas não conferem.');
      return;
    }
    setSalvando(true);
    try {
      await trocarSenha(senha);
      navigate('/dashboard');
    } catch (err) {
      const msgPorCodigo = {
        'auth/weak-password': 'Senha muito fraca. Use ao menos 6 caracteres.',
        'auth/requires-recent-login':
          'Por segurança, faça login novamente e troque a senha em seguida.',
        'auth/network-request-failed':
          'Falha de conexão. Verifique sua internet.',
      };
      setErro(
        msgPorCodigo[err.code] ||
          err.message ||
          'Não foi possível trocar a senha. Tente novamente.'
      );
    } finally {
      setSalvando(false);
    }
  }

  async function handleSair() {
    await logout();
    navigate('/login');
  }

  return (
    <div className={styles.wrap}>
      <form className={styles.card} onSubmit={handleSalvar}>
        <div className={styles.header}>
          <img
            className={styles.logoJatear}
            src={logoJatear}
            alt="Jatear Tratamento Anticorrosivo Ltda"
          />
        </div>

        <div className={styles.faixa}>Trocar senha — primeiro acesso</div>

        <div className={styles.form}>
          <div
            style={{
              background: '#FFF8E6',
              color: '#7A5200',
              border: '1px solid #F0C060',
              borderRadius: 8,
              padding: '10px 14px',
              fontSize: 13,
              marginBottom: 14,
            }}
          >
            Olá <strong>{usuario?.displayName || usuario?.email}</strong>! Por
            segurança, defina uma nova senha antes de continuar. A senha
            provisória deixará de funcionar.
          </div>

          <div className={styles.field}>
            <label htmlFor="senha">Nova senha</label>
            <input
              id="senha"
              type="password"
              placeholder="Mínimo 6 caracteres"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="new-password"
              disabled={salvando}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="confirmar">Confirmar nova senha</label>
            <input
              id="confirmar"
              type="password"
              placeholder="Repita a nova senha"
              value={confirmar}
              onChange={(e) => setConfirmar(e.target.value)}
              autoComplete="new-password"
              disabled={salvando}
            />
          </div>

          {erro && <div className={styles.erro}>{erro}</div>}

          <button
            type="submit"
            className={styles.btnEntrar}
            disabled={salvando}
          >
            {salvando ? 'Salvando...' : 'Definir nova senha'}
          </button>

          <button
            type="button"
            onClick={handleSair}
            style={{
              marginTop: 10,
              background: 'transparent',
              border: 'none',
              color: '#888',
              fontSize: 12,
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            Sair sem trocar senha
          </button>
        </div>

        <div className={styles.footer}>
          Jatear Tratamento Anticorrosivo Ltda &nbsp;·&nbsp; v1.0
        </div>
      </form>
    </div>
  );
}